import axios from 'axios';

/* global pageData */
/* eslint no-undef: "error" */
/* eslint no-param-reassign: ["error", { "props": false }] */

const trackingOnSuccess = () => {
  if (window.custom_dispatchEventAsync === undefined) return;
  const eventPayload = JSON.parse(JSON.stringify(pageData));

  eventPayload.page.name = eventPayload.page.name.replace(
    /:step([0-9]{1,}):.{1,}/,
    ''
  );
  eventPayload.page.name += ':success';
  eventPayload.page.event = 'bewerbenSuccess';
  window.custom_dispatchEventAsync(
    new CustomEvent('customPageView', { detail: eventPayload })
  );
};

const trackingOnError = (errormsg) => {
  if (window.custom_dispatchEventAsync === undefined) return;
  window.custom_dispatchEventAsync(
    new CustomEvent('formError', {
      detail: {
        errorType: `Fehler beim Absenden der Bewerbung: ${errormsg}`,
      },
    })
  );
};

export const trackingOnStepChange = (newStep) => {
  if (window.custom_dispatchEventAsync === undefined) return;

  const eventPayload = JSON.parse(JSON.stringify(pageData));

  eventPayload.page.name = eventPayload.page.name.replace(
    /:step([0-9]{1,}):.{1,}/,
    ''
  );
  eventPayload.page.name += `:step${newStep}`;
  window.custom_dispatchEventAsync(
    new CustomEvent('customPageView', { detail: eventPayload })
  );
};

const getTrackingDCC = () => {
  const a = 'dCC';
  const b = document.cookie.match(`(^|;)\\s*${a}\\s*=\\s*([^;]+)`);
  return b ? b.pop() : '';
};

const addScreeningQuestion = (data, key, label, value) => {
  let val = value;

  if (val === undefined) return;
  if (Array.isArray(val)) val = val.join(', ');
  if (typeof val === 'boolean') val = val ? 'Ja' : 'Nein';

  data.screeningQuestions.push({
    id: key,
    answer: val,
  });

  data.fields[label] = val;
};

const generateSubmitPayload = (publicationID, data) => {
  const sourceID = getTrackingDCC() || 'unknownsource';

  let { phone } = data.personal;
  if (phone.indexOf('+49') !== 0 && phone.indexOf('0049' !== 0)) {
    phone = phone.replace(/^0?([1-9]?[0-9]+)$/, '+49$1');
  }

  const apiDataSet = {
    sourceId: sourceID,
    type: 'ONLINE',
    languageId: 'de',
    refJobPublication: { id: publicationID },
    privacyPolicyAccepted: data.summary.consent.indexOf('privacy') !== -1,
    extendedUseAccepted: data.summary.consent.indexOf('extendedPrivacy') !== -1,
    Weitere_Infos: data.summary.notes || '',
    person: {
      salutation: data.personal.gender || '',
      firstName: data.personal.firstname || '',
      lastName: data.personal.lastname || '',
      email: data.personal.email || '',
      telephone: phone || '',
      dateOfBirth: data.dateOfBirth.date || '',
      countryIsoA2: data.address.country || '',
      address2: data.address.street || '',
      zipCode: data.address.postalCode || '',
      city: data.address.city || '',
      lastPosition:
        (data.experience && data.experience.previousOrCurrentJob) || '',
    },
    screeningQuestions: [],
    fields: {},
    overwrites: {},
    attachmentFiles: [],
  };

  apiDataSet.fields['Aktuelle oder letzte Tätigkeit'] =
    (data.experience && data.experience.previousOrCurrentJob) || '';

  if (data.upload) {
    let summaryValue = '';
    data.upload.documents.forEach((file) => {
      apiDataSet.attachmentFiles.push({
        fileName: file.name,
        origFilename: file.original,
      });
      summaryValue += `${file.original}\n`;
    });
    apiDataSet.fields.Unterlagen = summaryValue;
  }

  // prettier-ignore
  addScreeningQuestion(apiDataSet, 'BERUFSERFAHRUNG_JAHRE', 'Erfahrung in Jahren', data.experience && data.experience.yearsOfExperience);

  // prettier-ignore
  addScreeningQuestion(apiDataSet, 'FUEHRERSCHEIN_DATUM', 'Führerschein ausgestellt', data.driversLicence && data.driversLicence.date);

  // prettier-ignore
  addScreeningQuestion(apiDataSet, 'FUEHRERSCHEINKLASSE', 'Führerschein Klasse', data.driversLicence && data.driversLicence.licenceTypes);

  // prettier-ignore
  addScreeningQuestion(apiDataSet, 'DEUTSCHKENNTNISSE', 'Deutschkenntnisse', data.languageSkills && data.languageSkills.level);

  // prettier-ignore
  addScreeningQuestion(apiDataSet, 'ARBEITEN_AN_WOCHENENDEN', 'Arbeiten am Wochenende', data.workOnWeekends && data.workOnWeekends.checkboxAccept);

  // prettier-ignore
  addScreeningQuestion(apiDataSet, 'ERREICHBARKEIT_TAGESZEIT', 'Erreichbarkeit', data.info && data.info.availableAt);

  // prettier-ignore
  addScreeningQuestion(apiDataSet, 'ERREICHBARKEIT_ANMERKUNG', 'Anmerkung zur Erreichbarkeit', data.info && data.info.notes);

  // prettier-ignore
  addScreeningQuestion(apiDataSet, 'ALTERNATIVE_STELLEN', 'Alernative Stellen', data.otherJobs && data.otherJobs.job);

  // prettier-ignore
  addScreeningQuestion(apiDataSet, 'WIE_HOCH_SIND_DEINE_GEHALTSV', 'Wie hoch sind deine Gehaltsv.', data.salaryExpectations && data.salaryExpectations.salary);

  return apiDataSet;
};

// eslint-disable-next-line import/prefer-default-export
export const submitApplication = (apiEndPoint, jobID, publicationID, data) => {
  const bodyData = generateSubmitPayload(publicationID, data);

  return new Promise((resolve, reject) => {
    axios
      .post(apiEndPoint + jobID, bodyData)
      .then((response) => {
        if (response.status === 201 && response.data.success === true) {
          trackingOnSuccess();
          resolve();
        } else {
          trackingOnError(
            'Bitte überprüfe Deine eingegebenen Daten oder versuche es später erneut.'
          );
          reject(response.data.message);
        }
      })
      .catch((ex) => {
        trackingOnError(ex);
        reject(ex);
      });
  });
};
